import React from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import {
  FaFacebook,
  FaLinkedin,
  FaInstagram,
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhone,
} from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark text-white pt-0 pb-3 mt-0">
      <Container>
        <Row className="gy-4">
          {/* Column 1: School Identity */}
          <Col lg={4} md={6}>
            <h5 className="text-primary fw-bold mb-3">
              VIRIYA INTERNATIONAL SCHOOL
            </h5>
            <p className="small text-secondary">
              Providing flexible, quality international education for students
              from Kindergarten to Pre-University level.
            </p>
            <div className="d-flex gap-3 mt-3">
              <a href="#" className="text-white">
                <FaFacebook size={20} />
              </a>
              <a href="#" className="text-white">
                <FaInstagram size={20} />
              </a>
              <a href="#" className="text-white">
                <FaLinkedin size={20} />
              </a>
            </div>
          </Col>

          {/* Column 2: Quick Links (Navigates to sections) */}
          <Col lg={2} md={6}>
            <h6 className="fw-bold mb-3">Navigation</h6>
            <Nav className="flex-column small">
              <Nav.Link href="#home" className="text-secondary p-0 mb-2">
                Home
              </Nav.Link>
              <Nav.Link href="#programs" className="text-secondary p-0 mb-2">
                Programs
              </Nav.Link>
              <Nav.Link href="#about" className="text-secondary p-0 mb-2">
                About Us
              </Nav.Link>
              <Nav.Link href="#contact" className="text-secondary p-0 mb-2">
                Admissions
              </Nav.Link>
            </Nav>
          </Col>

          {/* Column 3: Contact Details from your text */}
          <Col lg={3} md={6}>
            <h6 className="fw-bold mb-3">Contact Us</h6>
            <ul className="list-unstyled small text-secondary">
              <li className="mb-2">
                <FaEnvelope className="me-2 text-primary" />
                info@viriya.education
              </li>
              <li className="mb-2">
                <FaPhone className="me-2 text-primary" />
                09651344666, 09890542633
              </li>
              <li className="mb-2 d-flex">
                <FaMapMarkerAlt className="me-2 text-primary mt-1" />
                <span>9A, Nat Mauk Yeik Thar St, Tarmwe Township, Yangon</span>
              </li>
            </ul>
          </Col>

          {/* Column 4: Opening Hours/Status */}
          <Col lg={3} md={6}>
            <h6 className="fw-bold mb-3">Learning Modes</h6>
            <p className="small text-secondary mb-1">
              💻 Online Learning Available
            </p>
            <p className="small text-secondary">🏫 On-Campus Learning</p>
            <div className="mt-3 p-2 bg-secondary bg-opacity-10 rounded border border-secondary border-opacity-25">
              <small className="text-primary fw-bold">
                Open for Enrollment
              </small>
            </div>
          </Col>
        </Row>

        <hr className="my-4 border-secondary" />

        <Row>
          <Col className="text-center">
            <p className="small text-secondary mb-0">
              &copy; {currentYear} Viriya International School. All rights
              reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
